"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _PictureFilled = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/PictureFilled"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var PictureFilled = function PictureFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _PictureFilled.default
  }));
};

/**![picture](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek0zMzggMzA0YzM1LjMgMCA2NCAyOC43IDY0IDY0cy0yOC43IDY0LTY0IDY0LTY0LTI4LjctNjQtNjQgMjguNy02NCA2NC02NHptNTEzLjkgNDM3LjFhOC4xMSA4LjExIDAgMDEtNS4yIDEuOUgxNzcuMmMtNC40IDAtOC0zLjYtOC04IDAtMS45LjctMy43IDEuOS01LjJsMTcwLjMtMjAyYzIuOC0zLjQgNy45LTMuOCAxMS4zLTEgLjMuMy43LjYgMSAxbDk5LjQgMTE4IDE1OC4xLTE4Ny41YzIuOC0zLjQgNy45LTMuOCAxMS4zLTEgLjMuMy43LjYgMSAxbDIyOS42IDI3MS42YzIuNiAzLjMgMi4yIDguNC0xLjIgMTEuMnoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/React.forwardRef(PictureFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PictureFilled';
}
var _default = exports.default = RefIcon;